import Api from './Api';

/** GET /logicbasediscoverfeeds — public discover feeds. */
class LogicBaseDiscoverFeedsApi extends Api {
  url = 'logicbasediscoverfeeds';
}

const singleton = new LogicBaseDiscoverFeedsApi();
export default singleton;
